<template>
  <!-- Subcription pay Modal -->
  <transition name="fade" v-if="!is_going_topay">
    <div class="pay-overlay">
      <div class="modal-widget">
        <div class="modal-header">
          <h2 v-html="title"></h2>
        </div>
        <div class="modal-body">
          <div class="modal-body-message">
            <p> You are about to vote <b>{{ participant.name }}</b></p>
            <p> You will be charged <b> {{ topup_fee }}% </b> from your balance of in progress voting
              session. This action can not be reverted.</p>
          </div>
          <div class="package-items" v-if="!isLoadingPrices">
            <div class="package-item" v-for="(item, index) in price_packages" :key="index"
              :class="{ active: item.id == form.selected_price }" @click="selectPackage(item)">
              <h2>{{ item.quantity }} Votes</h2>
              <p>{{ item.currency }} {{ item.amount }}</p>
              <img src="@/assets/images/icons/checked.svg" />
            </div>
          </div>
          <div class="loading-widget" v-if="isLoadingPrices">
            <loading :height="50" color="var(--wecodefy-secondary-color,#9fc953)" :opacity="1" :width="50"
              :active.sync="isLoadingPrices" :is-full-page="false" :can-cancel="false" background-color="#fff"
              class="loader"></loading>
          </div>
        </div>
        <div class="modal-Footer">
          <button class="btn-success" @click="next()">NEXT</button>
          <button class="btn-default" @click="cancelPayment()">CANCEL</button>
        </div>
      </div>
    </div>
  </transition>
  <!-- End of modal -->

  <!-- Payment widget modal -->
  <PaymentWidget v-else :amount="form.selected_amount" :payload="form" :currency="form.currency"
    @back="is_going_topay = false" @success="onSuccess" @initial="onStartPaying" @close="onClosePayment"
    url="/voting/topup/votes/to/participant"></PaymentWidget>

</template>
<script>
export default {
  name: "movie-pay",
  components: {},
  props: {
    title: {
      type: String,
      default: "Select a package",
    },
    participant: {
      type: Object,
      default: () => { },
    },
    session: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      payment_success: false,
      form: {
        participant_id: null,
        selected_price: null,
        selected_amount: 0,
        currency: "RWF",
        product: "voting_topup",
      },
      price_packages: [],
      is_going_topay: false,
      request_transaction_id: false,
      isLoadingPrices: false,
      topup_fee: 0,
    };
  },

  mounted() {
    let vm = this;
    vm.getVotingSessionPrices();
  },
  methods: {
    getVotingSessionPrices() {
      let vm = this;
      vm.isLoadingPrices = true;
      vm.$store
        .dispatch("VOTING_GET_VOTING_SESSION_PRICING_WITH_TOPUP_FEE", {
          session_id: vm.participant.session_id,
        })
        .then((response) => {
          vm.isLoadingPrices = false;
          vm.form.participant_id = vm.participant.id;
          vm.price_packages = response.data.return.pricing;
          vm.topup_fee = response.data.return.topup_fee;
          vm.price_packages.forEach((item, index) => {
            if (index == 0) {
              vm.form.selected_price = item.id;
              vm.form.selected_amount = item.amount;
              vm.form.currency = item.currency;
            }
          });
        })
        .catch((error) => {
          vm.isLoadingPrices = false;
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OPPS!!",
            text: "Failed to load voting session prices, Reflesh page",
          });
        });
    },
    selectPackage(item) {
      let vm = this;
      vm.form.selected_price = item.id;
      vm.form.selected_amount = item.amount;
      vm.form.currency = item.currency;
    },
    onSuccess(data) {
      let vm = this;
      clearInterval(vm.paying_timer);
      vm.paying_timer = null;
      vm.checkIfPayed();
    },
    onStartPaying(data) {
      let vm = this;
      vm.request_transaction_id = data.token;
      clearInterval(vm.paying_timer);
      vm.paying_timer = null;
      vm.checkIfPayed();
    },
    checkIfPayed() {
      let vm = this;
      vm.paying_timer = setInterval(() => {
        vm.$store
          .dispatch("PAYMENT_CHECK_STATUS", {
            request_transaction_id: vm.request_transaction_id,
          })
          .then((response) => {
            vm.payment_success = true;
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
            clearInterval(vm.paying_timer);
            setTimeout(() => {
              vm.$emit("onClose", { status: "ok" });
            }, 700);
          })
          .catch(({ response }) => { });
      }, 3000);
    },
    cancelPayment() {
      let vm = this;
      clearInterval(vm.paying_timer);
      vm.$emit("onCancel", null);
    },
    onClosePayment() {
      let vm = this;
      vm.is_going_topay = false;
      clearInterval(vm.paying_timer);
      vm.$emit("onCancel", null);
    },
    next() {
      let vm = this;
      vm.form.channel_id = vm.channel_id;
      clearInterval(vm.paying_timer);
      vm.is_going_topay = true;
    },
    back() {
      let vm = this;
      clearInterval(vm.paying_timer);
      vm.is_going_topay = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-overlay {
  position: fixed !important;
  left: 0px;
  bottom: 0px;
  right: 0px;
  top: 0px;
  z-index: 9999999;
  display: flex;
  background-color: rgba($color: #000000, $alpha: 0.8);
  padding-top: 80px;
  padding-bottom: 30px;

  .modal-widget {
    margin: 0 auto;
    width: 400px;
    height: 100%;
    background: #fff;
    border-radius: 5px;

    @media screen and (max-width: 500px) {
      width: 100%;
      position: fixed;
      z-index: 999999999999999;
      top: 0px;
      left: 0px;
      bottom: 0px;
      right: 0px;
      height: auto;
      display: flex;
      flex-direction: column;
    }

    .modal-header {
      height: 50px;
      border-bottom: 1px solid #ddd;
      display: flex;
      align-items: center;
      padding-left: 20px;

      h2 {
        margin: 0px;
        font-size: 0.8rem;
        text-transform: uppercase;
      }
    }

    .modal-body {
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: calc(100% - 105px);
      position: relative;
      overflow-y: auto;

      &.fitt-bottom {
        height: calc(100% - 55px);
      }

      .modal-body-message {
        text-align: center;
        margin-bottom: 20px;
        font-size: 0.9rem;
      }

      .package-items {
        width: 100%;
        display: grid;
        grid-template-columns: 47% 47%;
        grid-gap: 20px;

        .package-item {
          border: 1px solid #ddd;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          cursor: pointer;
          padding: 10px;
          border-radius: 5px;
          position: relative;

          img {
            width: 15px;
            height: 15px;
            position: absolute;
            top: 8px;
            left: 8px;
            display: none;
          }

          h2 {
            font-size: 1.2rem;
            margin: 0 0 8px;
          }

          p {
            font-size: 0.9rem;
          }

          &:hover {
            border: 1px solid var(--wecodefy-secondary-color, #9fc953);
          }

          &.active {
            border: 1px solid var(--wecodefy-secondary-color, #9fc953);

            h2 {
              color: var(--wecodefy-secondary-color, #9fc953);
            }

            p {
              color: var(--wecodefy-secondary-color, #9fc953);
            }

            img {
              display: block;
            }
          }
        }
      }

      .loading-widget {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
      }
    }

    .modal-Footer {
      display: flex;
      padding: 0px 20px;
      border-top: 1px solid #ddd;
      height: 60px;
      align-items: center;
      justify-content: space-between;

      @media screen and (max-width: 500px) {
        width: 100%;
        position: fixed;
        z-index: 999999999999999;
        left: 0px;
        bottom: 0px;
        right: 0px;
        display: flex;
        justify-content: center;
      }

      @media screen and (max-width: 340px) {
        padding-bottom: 5px;
      }

      .btn-success {
        margin-right: 20px;
      }
    }
  }
}
</style>